module.exports = __webpack_public_path__ + "img/bg.2d841a61.png";